export enum compareShareTexts {
    ARIAL_LABEL = "Поделится сравнением автомобилей",
    COPIED_SUCCESS = "Ссылка скопирована!",
    BUTTON_TEXT = "Поделится сравнением"
}